var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8741 12.2927L12.3016 18.8652C12.1313 19.0356 11.9291 19.1708 11.7066 19.2631C11.484 19.3554 11.2454 19.4029 11.0045 19.4029C10.7636 19.4029 10.525 19.3554 10.3024 19.2631C10.0799 19.1708 9.87769 19.0356 9.70742 18.8652L1.83325 11.0002V1.8335H10.9999L18.8741 9.70766C19.2155 10.0512 19.4072 10.5158 19.4072 11.0002C19.4072 11.4845 19.2155 11.9492 18.8741 12.2927Z",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.41675 6.4165H6.42675",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.f87307fd71e4161866c6b3b203c0ad89.svg";
export { ForwardRef as ReactComponent };